import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DashboardMenuService = {
  getList: async () => {
    try {
      const response = await apiService.get("/dashboardmenus");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/dashboardmenus/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  create: async (data) => {
    const response = await apiService.post("/dashboardmenus", data);
    return response.data;
  },

  getdetail: async (id) => {
    const response = await apiService.get(`/dashboardmenus/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/dashboardmenus/${id}`);
    return response.data;
  },
};

export default DashboardMenuService;
